import useAxiosInterceptor from '../interceptor';
import { apiPath } from './constants';

class PatientService {
  private axiosInstance;

  constructor() {
    this.axiosInstance = useAxiosInterceptor();
  }

  getSinglePatient = (payload: any) => {
    return this.axiosInstance.get(`${apiPath.PATIENT}/${payload.patientId}`);
  };

  createPatient = (payload: any) => {
    const headers = {
      Facility_id: payload.facilityUuid,
    };

    return this.axiosInstance.post(`${apiPath.PATIENT}`, payload, {
      headers: headers,
    });
  };
  editPatient = (payload: any) => {
    const headers = {
      Facility_id: payload.facilityUuid,
    };
    return this.axiosInstance.put(`${apiPath.PATIENT}/update`, payload, {
      headers: headers,
    });
  };

  deactivatePatient = (payload: any) => {
    const headers = {
      Facility_id: payload.facilityUuid,
    };
    return this.axiosInstance.delete(
      `${apiPath.PATIENT}/${payload?.patientId}?active=${payload?.active}`,
      {
        headers: headers,
        // params:payload?.active
      }
    );
  };

  getAllPhysician = (payload: any) => {
    return this.axiosInstance.get(`${apiPath.PHYSICIAN}/list`, {
      params: {
        ...payload,
      },
    });
  };

  getPayerPlanType = () => {
    return this.axiosInstance.get(`${apiPath.PAYERPLAN}/payer-type`);
  };
}

const patientService = new PatientService();

Object.freeze(patientService);

export default patientService;
